import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectOrganizationsSelectedProvider } from '../organizationsManagementSelectors'
import NettingUpdaterForm from './NettingUpdaterForm'
import NettingFtpsForm from './NettingFtpsForm'
import NettingApiForm from './NettingApiForm'
import NettingBatchList from './NettingBatchList'
import { Card, Header2 } from '@/shared/theme/styled-components'

const NETTING_FORMS = {
  file_upload: NettingUpdaterForm,
  ftps: NettingFtpsForm,
  api: NettingApiForm,
}

const NettingUpdaterPage = () => {
  const { t } = useTranslation('organizationManagement')
  const selectedProvider = useSelector(selectOrganizationsSelectedProvider)

  const nettingType = selectedProvider?.netting_process_type || 'file_upload'
  const FormComponent = NETTING_FORMS[nettingType] || NettingUpdaterForm

  return (
    <Card>
      <Header2>{t('netting.page_title')}</Header2>
      <FormComponent />
      <NettingBatchList />
    </Card>
  )
}

export default NettingUpdaterPage
